import http from "../utils/http-common";

class AuthorizationDataService {
    getAll() {
        return http.get("/authorization");
    }

    get(id) {
        return http.get(`/authorization/${id}`);
    }

    create(data) {
        return http.post("/authorization", data);
    }

    update(id, data) {
        return http.put(`/authorization/${id}`, data);
    }

    delete(id) {
        return http.delete(`/authorization/${id}`);
    }
}

export default new AuthorizationDataService();
